import loadStylesheet from '@fno/lib/load-stylesheet.js'
import template from './Hello.svelte'
import task from './task/task'
import welcome from './welcome/welcome'
import setup from './setup/setup'
import { getTabTool } from '@fno/service/api/tasks'

export default stateRouter => {
    const name = 'hello'

    stateRouter.addState({
        name,
        route: '/hello/:schoolId',
        template,
        resolve: async (ignore, { schoolId }) => {
            // NOTE: We use the client onboarding resource in the sidebar menu, so we
            // need to make sure it is loaded at the root of the resolve. (It's probably
            // loaded elsewhere in the routes, but since the request is cached it's not
            // an expensive problem to request it many times.)
            await getTabTool({ schoolId })
            return { schoolId }
        },
        defaultChild: 'task',
        activate: () => {
            loadStylesheet()
        }
    })

    setup(name, stateRouter)
    task(name, stateRouter)
    welcome(name, stateRouter)
}
